import React from 'react';

export const Home = () => (
  <>
    <h2 className="text-xl" data-cy="chancellor-welcome-title">
      Welcome to Oncolens Chancellor
    </h2>
    <p>
      This app serves as an interface to the new administration structure of organizations, users,
      and roles.
    </p>
  </>
);
